module.exports = __webpack_public_path__ + "static/img/failed_person.76efb8ef.png";